import React from 'react';
import ContentLoader from 'react-content-loader';
import './ServicesPage.scss';

const ServicesPageLoader = () => {
  return (
    <ContentLoader height={75}>
      <rect className="placeholder-rect-1" />
      <rect className="placeholder-rect-2" />
    </ContentLoader>
  );
};

export default ServicesPageLoader;



// WEBPACK FOOTER //
// ./src/components/pages/ServicesPage/ServicesPageLoader.js